import { Pipe, PipeTransform } from '@angular/core';
import { AgentSearchService } from '../../lib/services/agent-search';
import CustomStore from 'devextreme/data/custom_store';
import { AgentKeys } from '@ag-common-lib/public-api';

@Pipe({ name: 'agencyManagers' })
export class AgencyManagersPipe implements PipeTransform {
  constructor(private agentSearchService: AgentSearchService) {}

  transform(mgaId: string, agentId?: string) {
    return new CustomStore({
      byKey: payload => {
        return this.agentSearchService.getByAgentId(payload);
      },
      load: () => {
        return this.agentSearchService
          .search({
            filter: [[AgentKeys.is_manager, '=', true], 'and', [AgentKeys.p_mga_id, '=', mgaId]],
            sort: [{ selector: AgentKeys.p_agent_name, desc: false }],
          })
          .then(response => {
            const map = new Map();

            (response?.data ?? []).forEach(manager => {
              const managerAgentId = manager?.[AgentKeys.p_agent_id];

              if (agentId && agentId === managerAgentId) {
                return;
              }

              map.set(managerAgentId, manager);
            });

            return Array.from(map.values());
          });
      },
    });
  }
}
